import { CODINGAL_REWIND_YEAR } from '@common/constants'
import Logo from '@components/common/logo'
import styled from '@emotion/styled'

const Body = styled.div({
  background: '#0f0f0f',
  color: '#fff',
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '200px',
  '@media (max-width: 480px)': {
    gap: '0px',
  },
})

export default function ExpiredRewind() {
  return (
    <Body>
      <Logo
        withText
        className="absolute m-6 top-0 left-0"
        style={{ width: '120px', height: '32px' }}
        height={32}
        width={120}
        whiteText
      />
      <div className="text-2xl text-white">
        Hi there 👋 <br /> The{' '}
        <span className="text-orange font-700">
          Codingal Rewind {CODINGAL_REWIND_YEAR}
        </span>{' '}
        event has come to an end.
        <br /> See you in next year. 💖
      </div>
    </Body>
  )
}
